// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCalendar$dOpeningHours from "../Restaumatic.Calendar.OpeningHours/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic$dRestaurants$dTypes$dAddress from "../Restaumatic.Restaurants.Types.Address/index.js";
import * as Restaumatic$dRestaurants$dTypes$dDeliveryInfo from "../Restaumatic.Restaurants.Types.DeliveryInfo/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq2 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dRestaurants$dTypes$dDeliveryInfo.eqDeliveryInfo.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq3 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.eqFulfillmentMethodType)(Data$dEq.eqUnit).eq)();
const addressIsSymbol = {reflectSymbol: () => "address"};
const contactEmailIsSymbol = {reflectSymbol: () => "contactEmail"};
const contactPhoneNumberIsSymbol = {reflectSymbol: () => "contactPhoneNumber"};
const deliveryInfoIsSymbol = {reflectSymbol: () => "deliveryInfo"};
const fulfillmentMethodsIsSymbol = {reflectSymbol: () => "fulfillmentMethods"};
const idIsSymbol = {reflectSymbol: () => "id"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const restaurantHoursIsSymbol = {reflectSymbol: () => "restaurantHours"};
const slugIsSymbol = {reflectSymbol: () => "slug"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const RestaurantIsSymbol = {reflectSymbol: () => "Restaurant"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const Restaurant = x => x;
const toFillFormTypeRestaurant = {fillFormDataType: v => "unknown"};
const newtypeRestaurant_ = {Coercible0: () => {}};
const hasFieldRestaurant = dictHasField => dictHasField;
const eqRestaurant = {
  eq: x => y => Restaumatic$dRestaurants$dTypes$dAddress.eqAddress.eq(x.address)(y.address) && (() => {
    if (x.contactEmail.tag === "Nothing") { return y.contactEmail.tag === "Nothing"; }
    if (x.contactEmail.tag === "Just") {
      if (y.contactEmail.tag === "Just") { return x.contactEmail._1 === y.contactEmail._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.contactPhoneNumber.tag === "Nothing") { return y.contactPhoneNumber.tag === "Nothing"; }
    if (x.contactPhoneNumber.tag === "Just") {
      if (y.contactPhoneNumber.tag === "Just") { return x.contactPhoneNumber._1 === y.contactPhoneNumber._1; }
      return false;
    }
    return false;
  })() && eq2(x.deliveryInfo)(y.deliveryInfo) && eq3(x.fulfillmentMethods)(y.fulfillmentMethods) && x.id === y.id && x.name === y.name && Restaumatic$dCalendar$dOpeningHours.eqOpeningHours.eq(x.restaurantHours)(y.restaurantHours) && (() => {
    if (x.slug.tag === "Nothing") { return y.slug.tag === "Nothing"; }
    if (x.slug.tag === "Just") {
      if (y.slug.tag === "Just") { return x.slug._1 === y.slug._1; }
      return false;
    }
    return false;
  })()
};
const genericRestaurant = {to: x => x, from: x => x};
const showRestaurant = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.showFulfillmentMethodType);
      return {
        genericShowArgs: v => [
          "{ address: " + Restaumatic$dRestaurants$dTypes$dAddress.showAddress.show(v.address) + ", contactEmail: " + showMaybe.show(v.contactEmail) + ", contactPhoneNumber: " + showMaybe.show(v.contactPhoneNumber) + (() => {
            if (v.deliveryInfo.tag === "Just") {
              return ", deliveryInfo: (Just " + Restaumatic$dRestaurants$dTypes$dDeliveryInfo.showDeliveryInfo.show(v.deliveryInfo._1) + ")" + ", fulfillmentMethods: " + $0.show(v.fulfillmentMethods) + ", id: " + Data$dShow.showIntImpl(v.id) + ", name: " + Data$dShow.showStringImpl(v.name) + ", restaurantHours: " + Restaumatic$dCalendar$dOpeningHours.showOpeningHours.show(v.restaurantHours) + ", slug: " + showMaybe.show(v.slug) + " ";
            }
            if (v.deliveryInfo.tag === "Nothing") {
              return ", deliveryInfo: Nothing, fulfillmentMethods: " + $0.show(v.fulfillmentMethods) + ", id: " + Data$dShow.showIntImpl(v.id) + ", name: " + Data$dShow.showStringImpl(v.name) + ", restaurantHours: " + Restaumatic$dCalendar$dOpeningHours.showOpeningHours.show(v.restaurantHours) + ", slug: " + showMaybe.show(v.slug) + " ";
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(RestaurantIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeRestaurant = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(addressIsSymbol)(Restaumatic$dRestaurants$dTypes$dAddress.unscrambleDecodeAddress)(Unscramble.decodeRecordCons(contactEmailIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(contactPhoneNumberIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(deliveryInfoIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dRestaurants$dTypes$dDeliveryInfo.unscrambleDecodeDeliveryInfo))(Unscramble.decodeRecordCons(fulfillmentMethodsIsSymbol)(Unscramble.decodeSet(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.unscrambleDecodeFulfillmentMethodType)(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.ordFulfillmentMethodType))(Unscramble.decodeRecordCons(idIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(restaurantHoursIsSymbol)(Restaumatic$dCalendar$dOpeningHours.udecodeOpeningHours)(Unscramble.decodeRecordCons(slugIsSymbol)(decodeMaybe)(Unscramble.decodeRecordNil))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeRestaurant = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericRestaurant)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(RestaurantIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(slugIsSymbol)(encodeWithOptionsOther))(restaurantHoursIsSymbol)({
      encodeWithOptions: v => Restaumatic$dCalendar$dOpeningHours.encodeOpeningHours.encode
    }))(nameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(idIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(fulfillmentMethodsIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.encodeFulfillmentMethodType).encode;
      return {encodeWithOptions: v => encode1};
    })()))(deliveryInfoIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dRestaurants$dTypes$dDeliveryInfo.encodeDeliveryInfo.encode(v2._1); }
        $runtime.fail();
      }
    }))(contactPhoneNumberIsSymbol)(encodeWithOptionsOther))(contactEmailIsSymbol)(encodeWithOptionsOther))(addressIsSymbol)({
      encodeWithOptions: v => Restaumatic$dRestaurants$dTypes$dAddress.encodeAddress.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeRestaurant = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericRestaurant)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RestaurantIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(slugIsSymbol)(decodeWithOptionsOther)())(restaurantHoursIsSymbol)({
    decodeWithOptions: v => Restaumatic$dCalendar$dOpeningHours.decodeOpeningHours.decode
  })())(nameIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())(idIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(fulfillmentMethodsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.ordFulfillmentMethodType)(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.decodeFulfillmentMethodType).decode;
    return {decodeWithOptions: v => decode2};
  })())())(deliveryInfoIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dRestaurants$dTypes$dDeliveryInfo.decodeDeliveryInfo.decode)})())(contactPhoneNumberIsSymbol)(decodeWithOptionsOther)())(contactEmailIsSymbol)(decodeWithOptionsOther)())(addressIsSymbol)({
    decodeWithOptions: v => Restaumatic$dRestaurants$dTypes$dAddress.decodeAddress.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  Restaurant,
  RestaurantIsSymbol,
  addressIsSymbol,
  contactEmailIsSymbol,
  contactPhoneNumberIsSymbol,
  decodeMaybe,
  decodeRestaurant,
  decodeWithOptionsOther,
  deliveryInfoIsSymbol,
  encodeRestaurant,
  encodeWithOptionsOther,
  eq2,
  eq3,
  eqRestaurant,
  fulfillmentMethodsIsSymbol,
  genericRestaurant,
  hasFieldRestaurant,
  idIsSymbol,
  nameIsSymbol,
  newtypeRestaurant_,
  restaurantHoursIsSymbol,
  showMaybe,
  showRestaurant,
  slugIsSymbol,
  toFillFormTypeRestaurant,
  unscrambleDecodeRestaurant
};
